import React from 'react'
import { useIntl } from 'react-intl'
import { CheckCircleRounded } from '@mui/icons-material'
import { Box } from '@mui/material'
import { capitalize } from '../../../../../../utils/functions'
import {
    CourseSubjectPricePurchaseState,
    SelectedPurchaseSubjectState,
} from '../../../../../../features/types'
import {
    circleRounded,
    discountBox,
    fontMedium,
    selectedBox,
} from '../../style'

interface Props {
    courseSubjectPrice: CourseSubjectPricePurchaseState
    subject: SelectedPurchaseSubjectState
    duration: number
    selected?: boolean
    onSubjectClick: (
        subject: SelectedPurchaseSubjectState,
        courseSubjectPrice: CourseSubjectPricePurchaseState,
    ) => void
}
const SelectSubjectCard: React.FC<Props> = ({
    courseSubjectPrice,
    duration,
    selected = true,
    subject,
    onSubjectClick,
}) => {
    const styles = {
        subjectCardBox: {
            position: 'relative',
            border: '1px solid #EEEEEE',
            borderColor: selected ? 'primary.main' : '#EEEEEE',
            textAlign: 'center',
            padding: '8px',
            borderRadius: 1,
            mr: 4,
            mb: 2,
            width: '200px',
            cursor: 'pointer',
        },
    }
    const { formatMessage, locale } = useIntl()

    const getCourseDuration = (): string => {
        if (duration > 31) {
            const month = Math.trunc(duration / 30)
            return month + ' ' + formatMessage({ id: 'month' }).toLowerCase()
        }

        return duration + ' ' + formatMessage({ id: 'day' })
    }

    return (
        <Box
            sx={styles.subjectCardBox}
            onClick={() => onSubjectClick(subject, courseSubjectPrice)}
        >
            {selected && (
                <Box sx={selectedBox}>
                    <CheckCircleRounded
                        color="primary"
                        sx={circleRounded}
                    />
                </Box>
            )}

            {courseSubjectPrice?.discount > 0 && (
                <Box sx={discountBox}>-{courseSubjectPrice?.discount}%</Box>
            )}

            <Box sx={fontMedium}>{subject[`title${capitalize(locale)}`]}</Box>

            {courseSubjectPrice?.discount > 0 && (
                <Box sx={{ textDecoration: 'line-through' }}>
                    {courseSubjectPrice?.price}₸
                </Box>
            )}

            <Box sx={fontMedium}>
                {courseSubjectPrice?.discountPrice}₸ / {getCourseDuration()}
            </Box>
        </Box>
    )
}

export default SelectSubjectCard
